import React from 'react';
import PropTypes from 'prop-types';

const LoadMore = ({ currentPage, totalPages, onNavigate, resultsPerPage }) => (
  <div className="load-more">
    {resultsPerPage && totalPages > 1 && currentPage !== totalPages && (
      <button
        className="btn btn--primary"
        role="button"
        type="button"
        aria-label="Next page"
        onClick={() => {
          onNavigate(currentPage + 1);
        }}
      >
        View {resultsPerPage} More
      </button>
    )}
  </div>
);

LoadMore.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onNavigate: PropTypes.func.isRequired,
  resultsPerPage: PropTypes.number
};

export default LoadMore;
